module.exports = __webpack_public_path__ + "img/gjjhpc-w.05cc52e9.svg";